//Based on function: [Contracts].[fx_GetMarginDifferences] in "unpivoted" alias
export enum MarginEffectiveDateGroupId {
    PayRate = 1,
    BillRate = 2
}
